import { ChevronDown } from '../V3/icons'
import ImprovedDatePicker from '../../../../components/fields/ImprovedDatePicker'
import { useEffect, useRef, useState } from 'react'

export function TableFilter({ setFilter, fromDate, toDate, setFromDate, setToDate, filter }) {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const filterOptions = [
    {
      value: 'fuel',
      label: 'Drivstoff / lading',
    },
    {
      value: 'toll',
      label: 'Bompasseringer',
    },
    {
      value: 'workshop',
      label: 'Verkstedkostnad',
    },
    {
      value: 'park',
      label: 'Parkeringskostnad',
    },
  ]

  const getCurrentFilterLabel = () => {
    const currentFilter = filterOptions.find((option) => option.value === filter)
    return currentFilter ? currentFilter.label : 'Velg kategori'
  }

  const findActive = (activeFilter) => {
    switch (activeFilter) {
      case 'ALL':
        return 'hidden'
      case 'fuel':
        return 'translate-x-0'
      case 'toll':
        return 'translate-x-[150px]'
      case 'workshop':
        return 'translate-x-[300px]'
      case 'park':
        return 'translate-x-[450px]'
      default:
        return 'translate-x-0'
    }
  }

  const MobileDropdown = () => (
    <div className="md:hidden relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setDropdownOpen((prev) => !prev)}
        className="w-full bg-[#F1F3F9] px-4 py-3 rounded-lg flex items-center justify-between text-left font-bold shadow-lg"
      >
        <span>{getCurrentFilterLabel()}</span>
        <ChevronDown />
      </button>

      {dropdownOpen && (
        <div className=" absolute top-full left-0 right-0 mt-1 bg-white rounded-lg shadow-xl border z-50">
          {filterOptions.map((option) => (
            <button
              type="button"
              key={option.value}
              onClick={() => {
                setFilter(option.value)
                setDropdownOpen(false)
              }}
              className={`w-full px-4 py-3 text-left hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg flex items-center justify-between transition-colors ${
                filter === option.value ? 'bg-blue-50 text-blue-600 font-bold' : 'font-bold'
              }`}
            >
              {option.label}
              {option.value === 'park' && (
                <span className="px-2 py-1 rounded-full bg-blue-500 text-white text-xs">BETA</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  )

  return (
    <div className="flex w-full items-start lg:items-center justify-between gap-4 flex-col lg:flex-row">
      <MobileDropdown />
      <div className="hidden md:flex shadow-lg w-fit bg-[#F1F3F9] px-2 rounded-lg relative ">
        <div
          className={`${findActive(
            filter,
          )} min-w-[150px] transition-all transform ease-[cubic-bezier(0.68, -0.55, 0.27, 1.55)] duration-300 absolute bg-white h-[35px] rounded-lg shadow-sm top-1/2 -translate-y-1/2`}
        />
        {filterOptions.map((option) => {
          return (
            <button
              type="button"
              key={option.value}
              onClick={() => setFilter(option.value)}
              className="font-bold relative py-4 min-w-[150px] z-[2]"
            >
              {option.label}
              {option.value === 'park' && (
                <div className="px-4 absolute -right-2 -top-2 py-1 rounded-full bg-blue-500 text-white text-xs">
                  BETA
                </div>
              )}
            </button>
          )
        })}
      </div>
      <div className="flex z-[20] items-end gap-2 w-fit justify-end text-xs [&>*]:whitespace-nowrap">
        <div className="flex flex-col">
          <p>Fra</p>
          <ImprovedDatePicker selected={fromDate} language="nb" onChange={(data) => setFromDate(data)} />
        </div>
        <div className="flex flex-col">
          <p>Til</p>
          <ImprovedDatePicker selected={toDate} language="nb" onChange={(data) => setToDate(data)} />
        </div>
      </div>
    </div>
  )
}
